module.exports = __webpack_public_path__ + "img/symbol_9.3b32e181.png";